import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const ArtShell = ({ title, back = "/art", right, children, testid }) => {
  const nav = useNavigate();
  return (
    <div className="min-h-screen font-round" data-testid={testid}
      style={{ background: "radial-gradient(circle at 10% 0%,#fff3df,transparent 40%),radial-gradient(circle at 90% 20%,#ffe4ec,transparent 35%),#FFF8EE" }}>
      <header className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
        <button data-testid="art-back-btn" onClick={() => nav(back)} className="w-14 h-14 rounded-full bg-white border-2 border-[#f3d9b8] flex items-center justify-center shadow-sm active:scale-95"><ArrowLeft /></button>
        <h1 className="text-3xl sm:text-4xl font-black text-[#B4471F] flex-1 truncate">{title}</h1>
        {right}
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 pb-16">{children}</main>
    </div>
  );
};
